import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntrovert = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Introvert Icon",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Icon container",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M24.021 19.1397C23.1588 18.2775 21.9893 17.7931 20.77 17.7931H13.8734C12.654 17.7931 11.4846 18.2775 10.6223 19.1397C9.76011 20.002 9.27571 21.1714 9.27571 22.3908V28.1379",
					stroke: "currentColor",
					strokeWidth: 2.29885,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M17.3217 13.1954C19.8609 13.1954 21.9194 11.1369 21.9194 8.5977C21.9194 6.05846 19.8609 4 17.3217 4C14.7824 4 12.724 6.05846 12.724 8.5977C12.724 11.1369 14.7824 13.1954 17.3217 13.1954Z",
					stroke: "currentColor",
					strokeWidth: 2.29885,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M26.9424 22.1035L27.1965 22.7902C27.5297 23.6907 27.6963 24.141 28.0248 24.4694C28.3533 24.7979 28.8035 24.9645 29.704 25.2977L30.3907 25.5518L29.704 25.8059C28.8035 26.1391 28.3533 26.3057 28.0248 26.6342C27.6963 26.9626 27.5297 27.4129 27.1965 28.3133L26.9424 29.0001L26.6883 28.3133C26.3551 27.4129 26.1885 26.9626 25.8601 26.6342C25.5316 26.3057 25.0813 26.1391 24.1808 25.8059L23.4941 25.5518L24.1808 25.2977C25.0813 24.9645 25.5316 24.7979 25.8601 24.4694C26.1885 24.141 26.3551 23.6907 26.6883 22.7902L26.9424 22.1035Z",
					stroke: "currentColor",
					strokeWidth: 1.72414,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_4",
			d: "M5 8L5.22106 8.59745C5.51094 9.38087 5.65589 9.77259 5.94166 10.0583C6.22743 10.3441 6.61914 10.489 7.40257 10.7789L8 11L7.40257 11.2211C6.61914 11.511 6.22743 11.6559 5.94166 11.9417C5.65589 12.2274 5.51094 12.6191 5.22106 13.4025L5 14L4.77894 13.4025C4.48906 12.6191 4.34411 12.2274 4.05834 11.9417C3.77257 11.6559 3.38086 11.511 2.59743 11.2211L2 11L2.59743 10.7789C3.38086 10.489 3.77257 10.3441 4.05834 10.0583C4.34411 9.77259 4.48906 9.38087 4.77894 8.59745L5 8Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgIntrovert;
